import { useEffect } from 'react';

interface UseGameTimerProps {
  isGameActive: boolean;
  timeLeft: number;
  setTimeLeft: (updater: (prev: number) => number) => void;
  onTimeUp: () => void;
}

/**
 * 게임 타이머 관리 훅
 * 타이머는 작동하지만 시간이 끝나도 게임이 자동으로 종료되지 않습니다.
 * 자동 로그아웃 시간까지 게임이 계속됩니다.
 */
export const useGameTimer = ({
  isGameActive,
  timeLeft,
  setTimeLeft,
  onTimeUp,
}: UseGameTimerProps) => {
  useEffect(() => {
    if (!isGameActive) return;

    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          // 시간이 끝나도 게임을 종료하지 않음 (자동 로그아웃 시간까지 계속)
          // onTimeUp() 호출 제거
          return 0; // 0에서 멈춤
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [isGameActive, setTimeLeft, onTimeUp]);
};
